import React from 'react';

var PreElementFilter = function PreElementFilter(_ref) {
  var settings = _ref.settings,
      isDesktop = _ref.isDesktop,
      handleClick = _ref.handleClick,
      handleHorizontalScroll = _ref.handleHorizontalScroll,
      handleClickRight = _ref.handleClickRight,
      handleClickLeft = _ref.handleClickLeft,
      scrollPos = _ref.scrollPos,
      maxScroll = _ref.maxScroll,
      tags = _ref.tags;
  var keyCounter = 0;
  var preElementItems = settings.preElementItems || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, settings.preElementItems.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pre-element-wrapper",
    onScroll: handleHorizontalScroll,
    "data-tag": tags.join(' ')
  }, /*#__PURE__*/React.createElement("div", {
    className: "pre-element"
  }, preElementItems.map(function (preElement) {
    return /*#__PURE__*/React.createElement("div", {
      key: keyCounter++,
      className: "pre-element__item"
    }, isDesktop && preElement.type === 'text' && /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item__text",
      dangerouslySetInnerHTML: {
        __html: preElement.html.html
      }
    }), preElement.link && preElement.link.href && preElement.type === 'link' && /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item__link"
    }, /*#__PURE__*/React.createElement("a", {
      href: preElement.link.href && preElement.link.href,
      onClick: handleClick
    }, preElement.link.content)), !isDesktop && preElement.type === 'image' && /*#__PURE__*/React.createElement("div", {
      className: "pre-element__item__image",
      dangerouslySetInnerHTML: {
        __html: preElement.html.html
      }
    }));
  })), !isDesktop && settings.preElementItems.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: "mobile-chevron-arrows"
  }, scrollPos > 5 && /*#__PURE__*/React.createElement("div", {
    className: "chevron-wrapper-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chevron-arrow-left",
    onClick: handleClickLeft
  })), scrollPos + 5 < maxScroll && /*#__PURE__*/React.createElement("div", {
    className: "chevron-wrapper-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chevron-arrow-right",
    onClick: handleClickRight
  }))))));
};

export default PreElementFilter;